import { Field } from 'react-final-form';
import { required } from '../../../helpers';
import FormError from '../../Common/FormError';
import LocationWithAddress from '../../Common/LocationWithAddress';

const RentLoanForm = () => {
  return (
    <>
      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-3'>Project Name</label>
        <Field name='project_name' type='text' validate={(v) => required(v, 'Project name')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='text' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>

      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Rent Amount</label>
          <Field name='loan_amount' type='number' validate={(v) => required(v, 'Loan amount')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <label className='form-label mb-3'>Loan Tenure</label>
          <Field name='loan_tenure' type='number' validate={(v) => required(v, 'Loan tenure')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='number' placeholder='in months' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      <LocationWithAddress label='Property Address' addressFormName='property_address' cityFormName='property_city' stateFormName='property_state' countryFormName='property_country' />

      <label className='form-label mb-3 mt-5'>Home Owner's Detail</label>
      <div className='mb-5 col-lg-12'>
        <Field name='home_owners_name' type='text' validate={(v) => required(v, 'Name')}>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='text' {...input} className='form-control form-control-lg form-control-solid' placeholder='Name' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>
      <div className='row'>
        <div className='mb-5 col-lg-6'>
          <Field name='home_owners_phone' type='text' validate={(v) => required(v, 'Phone number')}>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='text' placeholder='Phone Number' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>

        <div className='mb-5 col-lg-6'>
          <Field name='home_owners_email' type='email'>
            {({ input, meta }) => (
              <>
                <div className='mb-3'>
                  <input type='text' placeholder='Email (Optional)' {...input} className='form-control form-control-lg form-control-solid' />
                  <FormError meta={meta} />
                </div>
              </>
            )}
          </Field>
        </div>
      </div>

      <div className='d-flex flex-stack mt-5 mb-5 col-lg-12'>
        <div className='me-5'>
          <label className='fs-6 fw-bold form-label'>Would you like to include the agent cost in the loan amount?</label>
        </div>

        <label className='form-check form-switch form-check-custom form-check-solid'>
          <Field name='include_agent_cost' type='checkbox'>
            {({ input, meta }) => (
              <>
                <input className='form-check-input' type='checkbox' {...input} />
                <FormError meta={meta} />
              </>
            )}
          </Field>
        </label>
      </div>

      <div className='mb-5 col-lg-12'>
        <label className='form-label mb-2'>Other Cost</label>
        <div className='fs-7 fw-bold text-gray-400'>Please note that some lenders may require you pay "other costs" up front to close the loan</div>
        <Field name='other_cost' type='number'>
          {({ input, meta }) => (
            <>
              <div className='mb-3'>
                <input type='number' {...input} className='form-control form-control-lg form-control-solid' />
                <FormError meta={meta} />
              </div>
            </>
          )}
        </Field>
      </div>
    </>
  );
};

export default RentLoanForm;
